import ButtonAnchor from "../basic/ButtonAnchor";

const RollingRush = () => {
  return (
    <main>

      <section className="articles">

        <article className="left-image">

          <img src="/images/games/rollingrush_appicon.png" alt="Rolling Rush Appicon" />
          <div>

            <h3 className="rolling-rush">Rolling Rush</h3>
            <p>
              My first game, Rolling Rush, is a casual game where you steer your ball left and right and jump over the wide variety of obstacles you encounter on your mission to finish the level, or get the highest score with endless mode!
            </p>
            <ButtonAnchor className="rolling-rush" to="https://apps.apple.com/gb/app/rolling-rush/id1602256144" text="Download for iOS" icon_path="/images/icons/appstore-icon.svg" alt_text="App Store Icon" />

          </div>

        </article>

        <article>
          <h3 className="rolling-rush">Play it now in your browser!</h3>
          <p>
            Rolling Rush can be played now in your browser! This version is not supported, and any minor bugs will not be fixed. Please still let me know (<a href="mailto:minibonzogames@gmail.com" className="rolling-rush">minibonzogames@gmail.com</a>) and known bugs will be posted here.
          </p>
          <ButtonAnchor className="rolling-rush" to="/play/rolling-rush/index.html" text="Click here to play now!" icon_path="/images/icons/play-icon.svg" alt_text="Play Button" />
        </article>

      </section>
      
    </main>
  );
}

export default RollingRush;